<template>
  <header :class="{ scrolled: isScrolled }" class="header">
    <v-main>
      <v-container>
        <v-row no-gutters align="center">
          <img
            src="@/assets/img/logo.svg"
            :width="$vuetify.breakpoint.smAndDown ? '30px' : '44px'"
            :height="$vuetify.breakpoint.smAndDown ? '22px' : '31px'"
          />
          <span class="site-title">Vivamus Gmbh</span>
          <v-row no-gutters justify="end" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="header-item" @click="$emit('goTo', '#main')">
              Startseite
            </div>
            <div class="header-item" @click="$emit('goTo', '#services')">
              Leistungen
            </div>
            <div class="header-item" @click="$emit('goTo', '#tools')">
              Tools
            </div>
            <div class="header-item" @click="$emit('goTo', '#reviews')">
              Referenzen
            </div>
            <div class="header-item" @click="$emit('goTo', '#contact')">
              Kontakt
            </div>
          </v-row>
        </v-row>
      </v-container>
    </v-main>
  </header>
</template>

<script>
export default {
  data: () => ({
    isScrolled: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
  },
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  background: transparent;
  transition: background 0.3s ease;
  z-index: 1000;
  height: 64px;
}

.header.scrolled {
  background: #f8f6f2;
}
.site-title {
  color: #ddae5a;
  font-family: "Julius Sans One";
  font-size: 30.242px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  margin-left: 12px;
}
@media (width <= 900px) {
  .site-title {
    font-size: 21.23px;
  }
}
.header-item {
  display: flex;
  width: max-content;
  height: max-content;
  padding: 10px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: #ebebeb;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-left: 32px;
  cursor: pointer;
  user-select: none;
}
.header-item:hover {
  background: rgb(192, 149, 89, 0.5);
  color: #f8f6f2;
}
.active-header-item {
  background: #c09559;
  color: #f8f6f2;
}
.scrolled .header-item {
  color: #3e7459!important;
}
</style>